import { call, put, select } from 'redux-saga/effects';
import { decodeToken } from '../utils/Utils';

import { API_CALL_STARTED, API_CALL_FINISHED, LOGOUT } from '../constants/Constants';

const getAccessToken = state => state.auth && state.auth.access_token;

export function* handleApiCall(type, apiCall, retrieveTokenFromStore, ...args) {
  const allArgs = [...args];
  try {
    if (retrieveTokenFromStore) {
      const token = yield select(getAccessToken);
      if (token) {
        const { exp } = decodeToken(token);
        if (exp <= (Date.now() / 1000)) {
          // token is not valid, log out
          yield put({ type: type.ERROR, payload: { message: 'Token expired' } });
          yield put({ type: LOGOUT.REQUESTED });
          return null;
        }
      }
      allArgs.push(token);
    }
    yield put({ type: API_CALL_STARTED });
    yield put({ type: type.PENDING });
    const res = yield call(apiCall, ...allArgs);
    yield put({ type: type.SUCCESS, payload: res.body });
    return res.body;
  } catch (error) {
    yield put({
      type: type.ERROR,
      payload: {
        error: (error.response && error.response.body) || { message: error.message },
        originalArgs: allArgs
      },
    });
  } finally {
    yield put({ type: API_CALL_FINISHED });
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/sagas/SagaUtils.js